// extracted by mini-css-extract-plugin
export default {"root":"cw4Yy","stats":"pAYYe","boosted":"_3wnEl","boosted-text":"_7X8qJ","boostedText":"_7X8qJ"};